<form [formGroup]="costForm" class="quantity-form">

  <div class="current-quantity-section">
    <div class="section-title">{{ 'pages.stock.edit.current_cost' | translate }}</div>
    <div class="quantity-display">
      <span class="quantity-number">{{ stockData.price | currencyFormat }}</span>
      <!-- <span class="quantity-label">{{ 'pages.stock.edit.units' | translate }}</span> -->
    </div>
  </div>


  <div>
    <div class="form-field">
      <label for="cost">{{ 'pages.stock.edit.new_cost' | translate }}:</label>
      <input type="number" id="cost" formControlName="cost" class="form-control"
        placeholder="{{ 'addStock.productCodePlaceholder' | translate }}">
    </div>
  </div>


  <div class="form-actions">
    <button type="button" class="btn btn-secondary" (click)="goBack()" [disabled]="isLoading">
      {{ 'common.back' | translate }}
    </button>
    <button type="button" class="btn btn-primary" [disabled]="costForm.invalid || isLoading" (click)="onSubmit()">
      <span *ngIf="isLoading" class="loading-spinner"></span>
      {{ 'pages.stock.edit.save_changes' | translate }}
    </button>
  </div>
</form>
